import React from 'react';
export function BrandMark() {
  return <a href="#top" className="inline-flex items-center gap-2.5 font-display text-xl font-bold uppercase tracking-[.02em] text-white no-underline" data-id="element-235" data-mp="22qqjnj98pd4a">
      <span aria-hidden="true" className="grid h-8 w-8 place-items-center rounded-lg bg-mint text-lg text-petrol" data-id="element-236" data-mp="3femk851vvrpe">
        ↗
      </span>
      Speech Therapy Ready
    </a>;
}